module.exports = __webpack_public_path__ + "static/media/light.171614cc.png";